module.exports = __webpack_public_path__ + "static/media/green-s.ff78eee1.svg";